import { Avatar, Box, Link, Paper, Stack, Typography } from '@mui/material';
import { NoDataFound2 } from 'Components';
import { mokedNumber } from 'Config';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { CallCenterLogoNoBG } from 'Images';

export const NoDataClaims = () => {
  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.Status);
  return (
    <Box mt={isDesktop ? 0 : '24px'}>
      <NoDataFound2
        gap={isDesktop ? '24px' : '32px'}
        headerComponent={
          <Stack alignItems={'center'}>
            <Typography
              variant='h3'
              color='text.secondary'
              alignSelf={'center'}
              mb='32px'
              width={isDesktop ? undefined : '200px'}
              textAlign='center'
            >
              {dictionary.title}
            </Typography>
            <Stack
              justifyContent={'center'}
              alignItems={'center'}
              rowGap='16px'
            >
              <Typography
                variant='body1'
                component='h4'
                color='text.secondary'
                marginRight={'5px'}
              >
                {dictionary.noData.title}
              </Typography>
              <Stack
                justifyContent={'center'}
                alignItems={'center'}
                textAlign='center'
              >
                <Typography variant={'body3'} color='text.secondary'>
                  {dictionary.noData.info}
                </Typography>
                <Typography variant={'body3'} color='text.secondary'>
                  {dictionary.noData.info2}
                </Typography>
              </Stack>
            </Stack>
          </Stack>
        }
        offerExtraText={false}
        footerComponent={
          <Paper
            sx={{
              padding: '16px',
              display: 'flex',
              flexFlow: 'column',
              alignItems: 'center',
              background: '#FFF',
              borderRadius: '16px',
              border: '1px solid #B7CCFF',
              boxShadow: 'none',
              textAlign: 'center',
              width: '400px',
              maxWidth: '100%',
            }}
          >
            <Avatar alt='' src={CallCenterLogoNoBG} sx={{ mb: '16px' }} />
            <Typography
              variant='body3'
              sx={{ maxWidth: isDesktop ? '260px' : '240px', mb: '8px' }}
            >
              {dictionary.noData.info3}
            </Typography>
            <Stack
              direction='row'
              textAlign='center'
              width='fit-content'
              columnGap='6px'
            >
              <Typography variant='body3'>{dictionary.noData.info4}</Typography>
              <Link sx={{ textDecoration: 'none', fontWeight: '600' }}>
                {mokedNumber}
              </Link>
            </Stack>
          </Paper>
        }
      />
    </Box>
  );
};
